export class StringUtil {

  static isEmpty (value: string): boolean {
    return value === '' || value === undefined || value === null || value.length === 0
  }

  static replaceSpaceWithPlus (value: string): string {
    return value.replaceAll(' ', '+')
  }

  static replacePlusWithSpace (value: string): string {
    return value.replaceAll('+', ' ')
  }
}
